export default "__VITE_ASSET__hwu_xzqM__"